import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { avatarReducer } from './avatar/avatar.reducer';
import { configReducer } from './config/config.reducer';
import { customOptionsReducer } from './customOptions/customOptions.reducer';
import { projectReducer } from './project/project.reducer';
import { userReducer } from './user/user.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AvatarEffects } from './avatar/avatar.effects';
import { ConfigEffects } from './config/config.effects';
import { ConfigService } from './config/config.service';
import { ProjectEffects } from './project/project.effects';
import { ProjectService } from './project/project.service';
import { environment } from 'src/environments/environment';
import { CustomSerializer } from './router/custom-route-serializer';
import {
  routerReducer,
  StoreRouterConnectingModule,
  RouterStateSerializer,
} from '@ngrx/router-store';
import { CustomOptionsService } from './customOptions/customOptions.service';
import { CustomOptionsEffects } from './customOptions/customOptions.effects';
import { soulfileReducer } from './soulfile/soulfile.reducer';
import { SoulfileEffects } from './soulfile/soulfile.effects';
import { SoulfileService } from './soulfile/soulfile.service';
import { schemaReducer } from './schema/schema.reducer';
import { SchemaEffects } from './schema/schema.effects';
import { SchemaService } from './schema/schema.service';
import { adminOrganizationReducer } from './admin-organization/admin-organization.reducer';
import { AdminOrganizationEffects } from './admin-organization/admin-organization.effects';
import { AdminOrganizationService } from './admin-organization/admin-organization.service';
import { adminOrganizationConfigReducer } from './admin-organization-config/admin-organization-config.reducer';
import { AdminOrganizationConfigEffects } from './admin-organization-config/admin-organization-config.effects';
import { AdminOrganizationConfigService } from './admin-organization-config/admin-organization-config.service';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { adminOrganizationAttrsReducer } from './admin-organization-attrs/admin-organization-attrs.reducer';
import { AdminOrganizationAttrsEffects } from './admin-organization-attrs/admin-organization-attrs.effects';
import { AdminOrganizationAttrsService } from './admin-organization-attrs/admin-organization-attrs.service';
import { manifestReducer } from './manifest/manifest.reducer';
import { ManifestEffects } from './manifest/manifest.effects';
import { ManifestService } from './manifest/manifest.service';
import { organizationUserReducer } from './organization-user/organization-user.reducer';
import { OrganizationUserEffects } from './organization-user/organization-user.effects';
import { OrganizationUserService } from './organization-user/organization-user.service';
import { analyticsReducer } from './analytics/analytics.reducer';
import { AnalyticsService } from './analytics/analytics.service';
import { AnalyticsEffects } from './analytics/analytics.effects';
import { UserEffects } from './user/user.effects';
import { UserService } from './user/user.service';
import { AccountTeamUserEffects } from './account-team-user/account-team-user.effects';
import { AccountTeamUserService } from './account-team-user/account-team-user.service';
import { accountTeamUserReducer } from './account-team-user/account-team-user.reducer';
import { insightsReducer } from './insights/insights.reducer';
import { InsightsEffects } from './insights/insights.effects';
import { InsightsService } from './insights/insights.service';
import { conversationNodeReducer } from './conversation-node/conversation-node.reducer';
import { ConversationNodeEffects } from './conversation-node/conversation-node.effects';
import { ConversationNodeService } from './conversation-node/conversation-node.service';
import { AuthLegacyService } from './user/auth-legacy.service';
import { userSearchReducer } from './user-search/user-search.reducer';
import { UserSearchEffects } from './user-search/user-search.effects';
import { UserSearchService } from './user-search/user-search.service';
import { VersionEffects } from './version/version.effects';
import { VersionService } from './version/version.service';
import { versionReducer } from './version/version.reducer';
import { SkillsEffects } from './skills/skills.effects';
import { SkillService } from './skills/skills.service';
import { skillsReducer } from './skills/skills.reducer';
import { adminCustomerDPReducer } from './admin-customer-dp/admin-customer-dp.reducer';
import { AdminCustomerDPEffects } from './admin-customer-dp/admin-customer-dp.effects';
import { AdminCustomerDPService } from './admin-customer-dp/admin-customer-dp.service';
import { adminSkillsReducer } from './admin-skills/admin-skills.reducer';
import { AdminSkillsEffects } from './admin-skills/admin-skills.effects';
import { apiKeyReducer } from './api-key/api-key.reducer';
import { ApiKeyEffects } from './api-key/api-key.effects';
import { ApiKeyService } from './api-key/api-key.service';
import { AdminApiKeyService } from './api-key/admin-api-key.service';
import { DownLoadFileService } from '../shared/services/download-file.service';
import { AdminApiKeyEffects } from './api-key/admin-api-key/admin-api-key.effects';
import { ApiKeyFormKey } from './api-key-form/api-key-form.selectors';
import { apiKeyFormReducer } from './api-key-form/api-key-form.reducer';
import { ApiKeyFormEffects } from './api-key-form/api-key-form.effects';
import { BlenderJobService } from './blender-job/blender-job.service';
import { AdminApiKeyFormEffects } from './api-key-form/admin-api-key-form.effects';
import { featureFlagsReducer } from './feature-flags/feature-flags.reducer';
import { FeatureFlagsEffects } from './feature-flags/feature-flags.effects';
import { FeatureFlagsKey } from './feature-flags/feature-flags.selectors';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { NotificationContentKey } from './notification-content/notification-content.selectors';
import { notificationContentReducer } from './notification-content/notification-content.reducer';
import { NotificationContentEffects } from './notification-content/notification-content.effects';
import { NotificationContentService } from './notification-content/notification-content.service';
import { NotificationContentFormKey } from './notification-content-form/notification-content-form.selectors';
import { notificationContentFormReducer } from './notification-content-form/notification-content-form.reducer';
import { NotificationContentFormEffects } from './notification-content-form/notification-content-form.effects';
import { customerDPReducer } from './customer-dp/customer-dp.reducer';
import { CustomerDpEffects } from './customer-dp/customer-dp.effects';
import { CustomerDPService } from './customer-dp/customer-dp.service';
import { uiReducer } from './ui/ui.reducer';
import { UIKey } from './ui/ui.selectors';
import { ProjectTemplateKey } from './project-template/project-template.selectors';
import { projectTemplateReducer } from './project-template/project-template.reducer';
import { ProjectTemplateEffects } from './project-template/project-template.effects';
import { ProjectTemplateService } from './project-template/project-template.service';
import { AdminProjectTemplateKey } from './admin-project-template/admin-project-template.selectors';
import { adminProjectTemplateReducer } from './admin-project-template/admin-project-template.reducer';
import { AdminProjectTemplateEffects } from './admin-project-template/admin-project-template.effects';
import { AdminProjectTemplateService } from './admin-project-template/admin-project-template.service';
import { widgetSnippetReducer } from './widget-snippet/widget-snippet.reducer';
import { WidgetSnippetEffects } from './widget-snippet/widget-snippet.effects';
import { WidgetSnippetService } from './widget-snippet/widget-snippet.service';
import { ProjectTemplateDefinitionKey } from './project-template-definition/project-template-definition.selectors';
import { projectTemplateDefinitionReducer } from './project-template-definition/project-template-definition.reducer';
import { ProjectTemplateDefinitionService } from './project-template-definition/project-template-definition.service';
import { ProjectTemplateDefinitionEffects } from './project-template-definition/project-template-definition.effects';
import { ConversationNodeKey } from './conversation-node/conversation-node.selectors';
import { NotificationReceiptKey } from './notification-receipt/notification-receipt.adapter';
import { notificationReceiptReducer } from './notification-receipt/notification-receipt.reducer';
import { NotificationReceiptEffects } from './notification-receipt/notification-receipt.effects';
import { NotificationReceiptService } from './notification-receipt/notification-receipt.service';
import { AdminSkillService } from './admin-skills/admin-skills.service';
import { ProjectEditFormKey } from './project-edit-form/project-edit-form.selectors';
import { projectEditFormReducer } from './project-edit-form/project-edit-form.reducer';
import { ProjectVideoKey } from './project-video/video/project-video.adapter';
import { projectVideoReducer } from './project-video/video/project-video.reducer';
import {
  Auth0ClientFactory,
  Auth0ClientService,
  AuthClientConfig,
  AuthConfigService,
} from '@auth0/auth0-angular';
import { usageSnapshotFeature } from './usage-snapshot/usage-snapshot.feature';
import { UsageSnapshotEffects } from './usage-snapshot/usage-snapshot.effects';
import { OrganizationSubscriptionModule } from './organization-subscription/organization-subscription.module';
import { SignUpEffects } from './sign-up/sign-up.effects';
import { SignUpService } from './sign-up/sign-up.service';
import { signUpFeature } from './sign-up/sign-up.feature';
import { ResendVerifyEmailEffects } from './resend-verify-email/resend-verify-email.effects';
import { ResendVerifyEmailService } from './resend-verify-email/resend-verify-email.service';
import { resendVerifyEmailFeature } from './resend-verify-email/resend-verify-email.feature';
import { PricingTableDialogModule } from './pricing-table-dialog/pricing-table-dialog.module';
import { accountTeamStripeRedirectReducer } from './account-team-stripe-redirect/account-team-stripe-redirect.reducer';

@NgModule({
  declarations: [],
  imports: [
    StoreRouterConnectingModule.forRoot({
      serializer: CustomSerializer,
    }),
    StoreModule.forRoot({
      analytics: analyticsReducer,
      apiKey: apiKeyReducer,
      [ApiKeyFormKey]: apiKeyFormReducer,
      avatar: avatarReducer,
      project: projectReducer,
      config: configReducer,
      customOptions: customOptionsReducer,
      user: userReducer,
      accountTeamStripeRedirect: accountTeamStripeRedirectReducer,
      accountTeamUser: accountTeamUserReducer,
      soulfile: soulfileReducer,
      schema: schemaReducer,
      adminOrganization: adminOrganizationReducer,
      adminOrganizationConfig: adminOrganizationConfigReducer,
      adminOrganizationAttrs: adminOrganizationAttrsReducer,
      adminSkill: adminSkillsReducer,
      organizationUser: organizationUserReducer,
      manifest: manifestReducer,
      router: routerReducer,
      insights: insightsReducer,
      userSearch: userSearchReducer,
      version: versionReducer,
      skill: skillsReducer,
      adminCustomerDP: adminCustomerDPReducer,
      customerDP: customerDPReducer,
      widgetSnippet: widgetSnippetReducer,
      [FeatureFlagsKey]: featureFlagsReducer,
      [NotificationContentKey]: notificationContentReducer,
      [ConversationNodeKey]: conversationNodeReducer,
      [NotificationContentFormKey]: notificationContentFormReducer,
      [UIKey]: uiReducer,
      [ProjectTemplateKey]: projectTemplateReducer,
      [AdminProjectTemplateKey]: adminProjectTemplateReducer,
      [ProjectTemplateDefinitionKey]: projectTemplateDefinitionReducer,
      [NotificationReceiptKey]: notificationReceiptReducer,
      [ProjectEditFormKey]: projectEditFormReducer,
      [ProjectVideoKey]: projectVideoReducer,
    }),
    StoreModule.forFeature(usageSnapshotFeature),
    StoreModule.forFeature(signUpFeature),
    StoreModule.forFeature(resendVerifyEmailFeature),
    EffectsModule.forRoot([
      ResendVerifyEmailEffects,
      SignUpEffects,
      FeatureFlagsEffects,
      AnalyticsEffects,
      ApiKeyEffects,
      ApiKeyFormEffects,
      AdminApiKeyFormEffects,
      AdminApiKeyEffects,
      AvatarEffects,
      ProjectEffects,
      ConfigEffects,
      CustomOptionsEffects,
      SoulfileEffects,
      SchemaEffects,
      AdminOrganizationEffects,
      AdminOrganizationConfigEffects,
      AdminOrganizationAttrsEffects,
      AdminSkillsEffects,
      OrganizationUserEffects,
      ManifestEffects,
      UserEffects,
      AccountTeamUserEffects,
      InsightsEffects,
      ConversationNodeEffects,
      UserSearchEffects,
      VersionEffects,
      SkillsEffects,
      AdminCustomerDPEffects,
      NotificationContentEffects,
      NotificationContentFormEffects,
      CustomerDpEffects,
      ProjectTemplateEffects,
      AdminProjectTemplateEffects,
      ProjectTemplateDefinitionEffects,
      WidgetSnippetEffects,
      NotificationReceiptEffects,
      UsageSnapshotEffects,
    ]),
    StoreDevtoolsModule.instrument({ maxAge: 100, logOnly: environment.production }),
    MatDialogModule,
    MatSnackBarModule,
    OrganizationSubscriptionModule,
    PricingTableDialogModule,
  ],
  providers: [
    ResendVerifyEmailService,
    SignUpService,
    AnalyticsService,
    ApiKeyService,
    AdminApiKeyService,
    ConfigService,
    ProjectService,
    CustomOptionsService,
    SoulfileService,
    SchemaService,
    AdminOrganizationService,
    AdminOrganizationConfigService,
    AdminOrganizationAttrsService,
    AdminSkillService,
    OrganizationUserService,
    ManifestService,
    UserService,
    AuthLegacyService,
    AccountTeamUserService,
    InsightsService,
    ConversationNodeService,
    UserSearchService,
    VersionService,
    SkillService,
    AdminCustomerDPService,
    DownLoadFileService,
    BlenderJobService,
    NotificationContentService,
    CustomerDPService,
    NotificationReceiptService,
    {
      provide: RouterStateSerializer,
      useClass: CustomSerializer,
    },
    ProjectTemplateService,
    AdminProjectTemplateService,
    ProjectTemplateDefinitionService,
    WidgetSnippetService,
    // temp fix - https://soulmachines.atlassian.net/browse/STUD-610
    {
      provide: AuthConfigService,
      useValue: AuthClientConfig,
    },
    {
      provide: Auth0ClientService,
      useFactory: Auth0ClientFactory.createClient,
      deps: [AuthClientConfig],
    },
  ],
})
export class AppStoreModule {}
